var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.5L7.0575 11.4425L2.8725 7.25L12 7.25L12 5.75L2.8725 5.75L7.0575 1.5575L6 0.499999L5.24537e-07 6.5L6 12.5Z",
    fill: "#69757C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowr);
export default __webpack_public_path__ + "static/media/left_arrowr.cb4dbdb77e705d60741a00d992736193.svg";
export { ForwardRef as ReactComponent };